export default __webpack_public_path__ + "static/media/ic_mim_24.b6a1708c.svg";